import Index from './Jobs'
import Form from './Form'
import Show from './Show'
import Requests from './Requests'
import IndexHeading from './IndexHeading'
import CreateHeading from './CreateHeading'
import EditHeading from './EditHeading'
import ShowHeading from './ShowHeading'
import RequestsHeading from './RequestsHeading'
import JobBoard from './JobBoard'
import JobBoardHeading from './JobBoardHeading'

export default {
  Index,
  Form,
  Show,
  Requests,
  IndexHeading,
  CreateHeading,
  EditHeading,
  ShowHeading,
  RequestsHeading,
  JobBoard,
  JobBoardHeading
}



// WEBPACK FOOTER //
// ./src/components/jobs/index.js